import { render, staticRenderFns } from "./FormReasonsReturnRefuse.vue?vue&type=template&id=40b98729&scoped=true&name=form-reasons-return-refuse&"
import script from "./FormReasonsReturnRefuse.vue?vue&type=script&lang=js&"
export * from "./FormReasonsReturnRefuse.vue?vue&type=script&lang=js&"
import style0 from "./FormReasonsReturnRefuse.vue?vue&type=style&index=0&id=40b98729&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b98729",
  null
  
)

/* custom blocks */
import block0 from "./FormReasonsReturnRefuse.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports